<div class="map-frame" [class.dragging]="!!drag" [style.height.px]="height"
	(pointerdown)="onPanDown($event)" (pointermove)="onMove($event)"
	(pointerup)="onUp($event)" (pointercancel)="onUp($event)"
	(wheel)="onWheel($event)" (dblclick)="onDblClick($event)">
	@for (t of tiles; track t.key) {
		<img class="tile" [src]="t.url" [style.left.px]="t.left" [style.top.px]="t.top" alt="" loading="lazy" />
	}
	@for (m of markers; track $index) {
		<!-- Épingle « goutte » : la POINTE (15,40 du viewBox) tombe exactement sur les coordonnées GPS
		     (translate(-50%,-100%)) ; au centre le n° d'arrêt dans la tournée, ou le repère de carte
		     (lettre) tant que la livraison n'est pas planifiée ; couleur de la tournée. -->
		<!-- pas de [title] : le tooltip natif ferait doublon avec le panneau d'aperçu BL au survol -->
		<div class="marker" [style.left.px]="m.left" [style.top.px]="m.top"
			(mouseenter)="onMarkerEnter(m)" (mouseleave)="onMarkerLeave()">
			<svg width="30" height="40" viewBox="0 0 30 40" aria-hidden="true">
				<path d="M15 40 C11 30.5 2.5 21.5 2.5 13 A12.5 12.5 0 1 1 27.5 13 C27.5 21.5 19 30.5 15 40 Z" [attr.fill]="m.color"/>
				<circle cx="15" cy="13" r="9" fill="#fff"/>
				<text x="15" [attr.y]="m.baseline" text-anchor="middle" [attr.font-size]="m.fontSize" font-weight="700" [attr.fill]="m.color">{{ m.text }}</text>
			</svg>
		</div>
	}
	@if (hover; as h) {
		<!-- Aperçu BL de l'épingle survolée : adresse complète + lignes du BL (cache par commande) -->
		<div class="map-hover" [style.left.px]="h.left" [style.top.px]="h.top"
			(mouseenter)="onHoverPanelEnter()" (mouseleave)="onHoverPanelLeave()"
			(pointerdown)="$event.stopPropagation()">
			<div class="mh-head">
				@if (h.m.ref) {
					<!-- le repère lu sur l'épingle : c'est lui qu'on retrouve sur la vignette du board -->
					<span class="mh-ref">{{ h.m.ref }}</span>
				}
				<span class="mh-title">#{{ h.m.delivery?.id_order }}</span>
				<span class="mh-customer">{{ h.m.label }}</span>
			</div>
			@if (h.details.length || h.tel) {
				<div class="mh-address">
					@for (l of h.details; track $index) { <div>{{ l }}</div> }
					@if (h.tel) { <div>Tél : {{ h.tel }}</div> }
				</div>
			}
			@if (h.loading) {
				<div class="mh-muted">Chargement du BL…</div>
			} @else if (h.error) {
				<div class="mh-error">Impossible de charger le contenu du BL</div>
			} @else {
				@if (h.preview; as p) {
					@if (!p.lines.length) {
						<div class="mh-muted">Aucune ligne dans ce BL</div>
					}
					<div class="mh-lines">
						@for (l of p.lines; track $index) {
							<div class="mh-line"><span class="mh-qty">{{ qtyOf(l.qty) }}</span><span class="mh-name">{{ l.name }}</span></div>
						}
					</div>
				}
			}
		</div>
	}
	@if (loading) {
		<div class="map-banner">Géocodage {{ done }}/{{ total }}…</div>
	}
	@if (!loading && failed.length) {
		<div class="map-banner warn">{{ failed.length }} adresse(s) non localisée(s)</div>
	}
	<div class="map-zoom">
		<button mat-mini-fab (click)="zoomBy(1)" aria-label="Zoom avant"><mat-icon>add</mat-icon></button>
		<button mat-mini-fab (click)="zoomBy(-1)" aria-label="Zoom arrière"><mat-icon>remove</mat-icon></button>
	</div>
	<div class="map-attrib">© OpenStreetMap</div>
</div>
